import { ValueFormatterParams } from "ag-grid-community";
import { Tabs } from "antd";
import React from "react";
import { GridType } from "../../../../../../../types/grid";
import { Popup, PopupTitle } from "../../../../../../atoms/Popup";
import { formatDateByType } from "../../../../../../libs/utils";
import { useTorRules } from "../../../../hooks/useTorRules";
import { ViewBillingSchedule, ViewTORSchedule } from "../../../schedule";
import type { GetBillingScheduleResult } from "../api";

const torColumns: GridType[] = [
  {
    id: "startDate",
    field: "startDate",
    headerName: "From",
    flex: 1,
    valueFormatter: ({ value }: ValueFormatterParams) => formatDateByType(value) ?? "",
  },
  {
    id: "endDate",
    field: "endDate",
    headerName: "To",
    flex: 1,
    valueFormatter: ({ value }: ValueFormatterParams) => formatDateByType(value) ?? "",
  },
  {
    id: "dueDate",
    field: "dueDate",
    headerName: "Due Date",
    flex: 1,
    valueFormatter: ({ value }: ValueFormatterParams) => formatDateByType(value) ?? "",
  },
];

type BillingSchedulePreviewModalProps = {
  isOpen: boolean;
  onClose: () => void;
  billingSchedulePreviewData: GetBillingScheduleResult;
  yearNumber: number;
  hasValidTorType?: boolean;
};

export const BillingSchedulePreviewModal = (props: BillingSchedulePreviewModalProps) => {
  const { isOpen, onClose, billingSchedulePreviewData, yearNumber, hasValidTorType } = props;
  const { isTurnoverRentOnly } = useTorRules();

  const { baseRentPaymentSchedule, torschedule } = billingSchedulePreviewData;

  const tabItems = [
    ...(!isTurnoverRentOnly
      ? [
          {
            key: "baseRent",
            label: "Base Rent Payment",
            children: <ViewBillingSchedule rows={baseRentPaymentSchedule} />,
          },
        ]
      : []),
    ...(hasValidTorType
      ? [
          {
            key: "tor",
            label: "TOR",
            children: <ViewTORSchedule columns={torColumns} rows={torschedule} grandTotalPinnedRow={[]} />,
          },
        ]
      : []),
  ];

  return (
    <Popup
      closable
      visibility={isOpen}
      style={{ padding: 0 }}
      width="79rem"
      onCancel={onClose}
      title={<PopupTitle title={`Billing Schedule — Year ${yearNumber}`} />}
      content={<Tabs items={tabItems} style={{ padding: "0 16px" }} />}
    />
  );
};
